'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

exports['default'] = _assertThisInitialized;
//# sourceMappingURL=assertThisInitialized.js.map
